import React from 'react';

import InnerTabs from 'components/InnerTabs';
import MediaSmDown from 'components/Responsive/MediaSmDown';

import Equipped from './components/Equipped';
import Inventory from './components/Inventory';
import Lodgings from './components/Lodgings';
import OutfitControl from './components/OutfitControl';

import PossessionsContext from './PossessionsContext';

interface Props {
  isFetching: boolean,
}

export default function PossessionsComponent({ isFetching }: Props) {
  return (
    <div className="possessions">
      <MediaSmDown>
        <InnerTabs />
      </MediaSmDown>
      <h1 className="heading heading--1 heading--close">My Possessions</h1>
      <hr />
      <div className="possessions__lodgings-and-equipped">
        <div className="u-text-center possessions__lodgings-and-outfit-control">
          {!isFetching && <Lodgings />}
          <OutfitControl />
        </div>
        <Equipped />
      </div>
      <hr />

      <PossessionsContext.Consumer>
        {({ categories, filterString, onFilter }) => (
          // @ts-ignore
          <Inventory
            categories={categories}
            filterString={filterString}
            onFilter={onFilter}
          />
        )}
      </PossessionsContext.Consumer>
    </div>
  );
}
